<template>
    <div class="recipe-details">
        <div class="details-container">
            <p v-test:serves>
                serves {{ serves }}
            </p>
            <span aria-hidden="true">|</span>
            <p v-test:prepTime>
                prep time {{ prepTime }}
            </p>
            <span aria-hidden="true">|</span>
            <p v-test:cookTime>
                cook time {{ cookTime }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'recipe-details',

        props: {
            serves: {
                type: Number,
                required: true,
            },

            prepTime: {
                type: String,
                required: true,
            },

            cookTime: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .details-container {
        display: flex;
        flex-wrap: wrap;
    }

    p {
        font-size: rem(20px);
        margin-bottom: 0;

        @include media-breakpoint-up(md) {
            font-weight: 300;
        }
    }

    span {
        font-size: rem(20px);
        padding: 0 4px;
    }
</style>
